import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import { disposeModal } from "../utils/modal-dispose.util"

// Opens the static "About Lucanto" modal from the user settings menu.
// The trigger lives inside the profile dropdown while the modal markup is a
// sibling of the dropdown menu, so both share this controller's element scope.
// Bootstrap's declarative data-api isn't globally loaded in this app, so the
// modal is shown imperatively (mirroring the bs-modal controller).
export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this.cleanup = this.cleanup.bind(this)
    document.addEventListener("turbo:before-cache", this.cleanup)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.cleanup)
    this.cleanup()
  }

  open(event) {
    event.preventDefault()
    Modal.getOrCreateInstance(this.modalTarget).show()
  }

  // Tear down the modal before Turbo caches the page so a stray backdrop or a
  // locked body scroll never leaks onto the next visit.
  cleanup() {
    if (!this.hasModalTarget) return

    const instance = Modal.getInstance(this.modalTarget)
    if (!instance) return

    disposeModal(instance)
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove())
    document.body.classList.remove("modal-open")
    document.body.style.removeProperty("overflow")
    document.body.style.removeProperty("padding-right")
  }
}
